import { useEffect } from 'react';
import { BACK_TO_STORAGE_KEY, INSTANCE_NAME_STORAGE_KEY } from '../constants';
import { useAuthorizationDetails } from './useAuthorizationDetails';

const syncSessionStorage = (key: string, value: string | null) => {
  if (value) {
    sessionStorage.setItem(key, value);
  } else {
    sessionStorage.removeItem(key);
  }
};

export const usePersistAuthorizationDetails = () => {
  const { instanceName, backTo } = useAuthorizationDetails();

  useEffect(() => {
    syncSessionStorage(INSTANCE_NAME_STORAGE_KEY, instanceName);
    syncSessionStorage(BACK_TO_STORAGE_KEY, backTo);
  }, [instanceName, backTo]);
};
